import type {
  RecentExpenseActivityResponseDTO,
  RecentExpenseActivityItemDTO,
} from "../api/clientOverviewApi";
import type {
  RecentExpenseActivityEntity,
  RecentExpenseActivityItemEntity,
} from "../../domain/entities/RecentExpenseActivityEntity";

function formatDateShort(iso: string): string {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    if (isNaN(d.getTime())) return iso;
    return d.toLocaleDateString("en-US", { month: "short", day: "numeric" });
  } catch {
    return iso;
  }
}

function itemDtoToEntity(dto: RecentExpenseActivityItemDTO): RecentExpenseActivityItemEntity {
  return {
    id: dto.id,
    date: formatDateShort(dto.date),
    billNo: dto.billNo ?? "—",
    vendor: dto.vendor ?? "—",
    category: dto.category ?? "—",
    amount: dto.amount ?? "—",
    status: dto.status,
    dueDate: formatDateShort(dto.dueDate),
  };
}

export function recentExpenseActivityDtoToEntity(
  dto: RecentExpenseActivityResponseDTO
): RecentExpenseActivityEntity {
  return {
    items: (dto.items ?? []).map(itemDtoToEntity),
    pagination: {
      total: dto.pagination?.total ?? 0,
      limit: dto.pagination?.limit ?? 10,
      page: dto.pagination?.page ?? 1,
      totalPages: dto.pagination?.total_pages ?? 0,
      hasMore: dto.pagination?.has_more ?? false,
    },
  };
}
